import { Button, Icon } from '@chakra-ui/react';
import { FC, useRef, useEffect, useState } from 'react';

import CaretSmall from '@/assets/icons/ic-caret-small.svg';

import { IScrollShadowsProps, ScrollShadows } from '@/components/core/ScrollShadows/ScrollShadows';
import { matchCueById, scrollToCue } from '@/components/ui/shared/transcripts/TranscriptText/TranscriptText.utils';
import useEventListener from '@/hooks/useEventListener';

import { Cue } from './components/Cue';

interface ITranscriptText extends IScrollShadowsProps {
  cues: Array<VTTCue>;
  activeCues?: Array<VTTCue>;
  onCueClick?: (cue: VTTCue) => void;
}

export const TranscriptText: FC<ITranscriptText> = ({ cues, activeCues, onCueClick, ...restProps }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const firstActiveCueRef = useRef<HTMLDivElement>(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (!showButton) {
      scrollToCue(firstActiveCueRef.current, containerRef.current);
    }
  }, [activeCues, showButton]);

  const scrollHandler = () => {
    setShowButton(true);
  };

  useEventListener('wheel', scrollHandler, containerRef.current);
  useEventListener('touchmove', scrollHandler, containerRef.current);

  const handleShowFocusButtonClick = () => {
    setShowButton(false);
  };

  return (
    <ScrollShadows
      ref={containerRef}
      fontFamily="body"
      overlay={
        showButton && (
          <Button size="xs" position="absolute" bottom="1" right="1" onClick={handleShowFocusButtonClick}>
            <Icon as={CaretSmall} transform="rotate(180deg)" />
          </Button>
        )
      }
      {...restProps}
    >
      {cues?.map((cue) => {
        const isActive = Boolean(activeCues?.find(matchCueById(cue)));
        const isFirstActiveCue = firstActiveCueRef.current === null;

        return (
          <Cue
            key={cue.id}
            isActive={isActive}
            cue={cue}
            containerRef={containerRef}
            onClick={onCueClick}
            ref={isActive && isFirstActiveCue ? firstActiveCueRef : null}
          />
        );
      })}
    </ScrollShadows>
  );
};
